import Player from '@vimeo/player';

// Global registry to store all Vimeo players across all instances
window.vimeoPlayerRegistry = window.vimeoPlayerRegistry || {
  players: [],
  stopAllExcept(currentPlayer) {
    this.players.forEach(player => {
      if (player !== currentPlayer && player && typeof player.pause === 'function') {
        try {
          // Check if player is ready before attempting to pause
          player.ready().then(() => {
            player.pause();
          }).catch(() => {
            // Player is not ready or unloaded, ignore
          });
        } catch (error) {
          // Silent cleanup
        }
      }
    });
  }
};

export default (blockId) => ({
  blockId,
  fullVideoPlaying: false,
  turboLoaded: true,
  videoLoaded: false,
  player: null,

  options: {
    dnt: true,
  },

  init() {
    const vimeoFullWrapper = document.getElementById(`vimeo-full-${this.blockId}`);
    if (vimeoFullWrapper && vimeoFullWrapper.dataset.id) {
      const vimeoFullId = vimeoFullWrapper.dataset.id;

      // Create a div to host the Vimeo player
      const playerDiv = document.createElement('div');
      playerDiv.style.width = '100%';
      playerDiv.style.height = '100%';
      vimeoFullWrapper.appendChild(playerDiv);

      // Initialize Vimeo Player immediately with poster
      this.player = this.initVideo(playerDiv, {
        id: vimeoFullId,
        width: 1087,
        muted: false,
        responsive: true,
        poster: true, // Enable poster image
        ...this.options,
      });

      // Add to global registry
      window.vimeoPlayerRegistry.players.push(this.player);

      // Add event listeners
      this.player.on('ended', () => this.stopFullVideo());
      this.player.on('play', () => window.vimeoPlayerRegistry.stopAllExcept(this.player));
    }

    for (let index = 1; index < 3; index++) {
      const wrapper = document.getElementById(`vimeo-small-${index}`);
      if (wrapper && wrapper.dataset.id) {
        const player = this.initVideo(wrapper, {
          id: wrapper.dataset.id,
          width: 348,
          muted: false,
          responsive: true,
          ...this.options,
        });

        // Add to global registry
        window.vimeoPlayerRegistry.players.push(player);

        player.on('play', () => {
          window.vimeoPlayerRegistry.stopAllExcept(player);
          this.stopFullVideo();
        });
      }
    }
  },

  initVideo(elementOrId, options) {
    return new Player(elementOrId, options);
  },

  stopFullVideo() {
    if (this.player) {
      try {
        this.player.pause();
      } catch (error) {
        // Silent cleanup
      }
    }

    this.fullVideoPlaying = false;
    this.videoLoaded = false; // Show the poster again
  },

  playFullVideo() {
    const el = document.getElementById(`vimeo-full-${this.blockId}`);
    if (!el || !el.dataset.id || !this.player) {
      return;
    }

    if (this.fullVideoPlaying) {
      this.stopFullVideo();
      return;
    }

    // Stop all other videos first
    window.vimeoPlayerRegistry.stopAllExcept(this.player);

    this.fullVideoPlaying = true;
    this.videoLoaded = true; // Hide the poster

    // Play the video
    this.player.play();
  },
});
